import React from "react"
import styled from "styled-components"
import Link from "~/components/Link"

const Wrapper = styled.div`
  text-align: right;
  
  a {
    font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
    font-size: 14px;
  }
`

const UseSavedPaymentData = ({ children, ...props }) => (
  <Wrapper>
    <Link {...props}>{children}</Link>
  </Wrapper>
)

export default UseSavedPaymentData
